import { render, staticRenderFns } from "./OneProjectCarousel.vue?vue&type=template&id=60c3b164&"
import script from "./OneProjectCarousel.vue?vue&type=script&lang=js&"
export * from "./OneProjectCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports